export const FEATURE_KEYS = {
  DUBBING: 'dubbing',
  RECAPTCHA_TRY_LISTEN_TTS_TYPE: 'recaptcha-try-listen-tts-type',
  RECAPTCHA_TTS_TYPE: 'recaptcha-tts-type',
  TRY_LISTEN_TTS: 'try-listen-tts',
  NEW_PLAY_AUDIO_LINK: 'new-play-audio-link',
  HIGHLIGHT_TO_PREVIEW: 'highlight-to-preview',
  SUBSCRIPTION: 'subscription',
  DUBBING_BY_UNIT_SECOND: 'dubbing-by-unit-second',
  MULTIPLE_INPUT_DUBBING: 'multiple-input-dubbing',
  DISCOUNT_FOR_FIRST_PAID_USER: 'discount-for-first-paid-user',
  VOICE_CLONING: 'voice-cloning',
  NEW_DUBBING_UI: 'new-dubbing-ui',
  STREAMING_PREVIEW: 'streaming-preview',
  DUBBING_SUBTITLE_TIMELINE: 'dubbing-subtitle-timeline',
  AUTO_RENEW_MOMO: 'auto-renew-momo', // Use auto-renew with momo
  DUBBING_PROJECTS: 'dubbing-projects',
  MULTIPLE_LANGUAGES_SRT: 'multiple-languages-srt',
  VIEW_VIDEO_WITH_TIMELINE: 'view-video-with-timeline',
  STT: 'stt',
  DATASENSES: 'datasenses',
  HEADER_BANNER_FLASH_SALE: 'header-banner-flash-sale',
  FAKE_END_TIME_VOUCHER: 'fake-time-voucher',
  BLOCK_SPAM_EMAIL: 'block-spam-email',
  NEW_REQUESTS_LAYOUT: 'new-requests-layout',
  INFINITE_SCROLL_REQUESTS: 'infinite-scroll-requests',
  VC_NEW_RECORDING: 'vc-new-recording',
  NEW_DICTIONARY_UI: 'new-dictionary-ui',
  ICON_NEW_DICTIONARY: 'icon-new-dictionary',
  NEW_POPUP_CHOOSE_VOICE: 'new-popup-choose-voice',
  BANNER_HOMEPAGE: 'banner-homepage',
  SUGGEST_DICTIONARY: 'suggest-dictionary',
  NEW_VOICES_LIST: 'new-voices-list',
  NEW_PRODUCTS_LIST: 'new-products-list',
  READ_DICTIONARY: 'read-dictionary',
  PUSH_EVENT_VIEW_PRICING: 'push-event-view-pricing',
  NEW_UX_SYNTHESIS: 'new-ux-synthesis',
  RENAME_MERGE_PRODUCT: 'rename-merge-product',
  NEW_HATE_SPEECH_DETECTOR: 'new-hate-speech-detector',
  NON_VBEE_CREDITS_FACTOR: 'non-vbee-credits-factor',
  VOICE_CREDITS_BY_LEVEL: 'voice-credits-by-level',
  PROMOTED_PACKAGE_MOE: 'promoted-package-moe',
  SYNC_AFFILIATE_MARKETER: 'sync-affiliate-marketer',
  SENTRY_AIVOICE_WEB_APP: 'sentry-aivoice-web-app',
  PERMATE_TRACKING: 'permate-tracking',
  NEW_DUBBING_REQUESTS_LIST: 'new-dubbing-requests-list',
  NON_VBEE_BREAK_TIME: 'non-vbee-break-time',
  AI_EDITTING: 'ai-editing',
  NEW_HEADER_UI: 'new-header-ui',
  VNPAY_DISCOUNT_INFO: 'vnpay-discount-info',
  MULTILINGUAL_VOICE: 'multilingual-voice',
  NEW_QR_FLOW: 'new-qr-flow',
  USE_USAGE_OPTIONS_IN_PACKAGE: 'use-usage-options-in-package',
  PAYMENT_QR_V2: 'payment-qr-v2',
  REFUND_PRICE_CURRENT_PLAN: 'refund-price-current-plan',
  VOICE_SELECTION_NOTICE: 'voice-selection-notice',
  LOCK_ONE_TIME_CREDITS_ADVANCED_VOICE: 'lock-one-time-credits-advanced-voice',
  SIGNUP_SURVEY: 'signup-survey',
  PROJECT: 'project',
  VALIDATE_VOICE_CLONING_ON_PLAN_CHANGE:
    'validate-voice-cloning-on-plan-change',
  NEW_CONTACT_SUPPORT: 'new-contact-support',
  UPDATE_VOICES_BY_USER_EOL_DATE: 'update-voices-by-user-eol-date',
  VOUCHER_FOR_AUTO_RENEW: 'voucher-for-auto-renew',
  VOICE_HAS_BEEN_RENAMED: 'voice-has-been-renamed',
  EMPHASIS_FEATURE_V2: 'emphasis-feature-v2',
  BANK_CONFIG: 'bank-config',
  PUSH_EVENT_TO_GTM_SERVER: 'push-event-to-gtm-server',
  USE_PUBLIC_VOICE_CLONING: 'use-public-voice-cloning',
  SLIDER_CREDITS: 'slider-credits',
  REFERRAL: 'referral',
  REFERAL_SHARING: 'referral-sharing',
  REFERAL_SHARING_VIA_MESSENGER: 'referral-messenger-share',
  ROLLOVER_CREDITS: 'rollover-credits',
  NEW_VOICE_CLONING: 'new-voice-cloning',
  LIMIT_REDEEM_CHARACTER_PER_MONTH: 'limit-redeem-character-per-month',
};
